import { useMutation, useQueryClient } from "@tanstack/react-query";

import { cancelFieldReactivation } from "services";

import { invalidateFieldParticipationQueries } from "utils";

import { CANCEL_FIELD_REACTIVATION } from "consts";

export const useCancelFieldReactivation = (fieldId: string, farmId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [CANCEL_FIELD_REACTIVATION, fieldId],
    mutationFn: () => cancelFieldReactivation(fieldId),
    onSuccess: () => invalidateFieldParticipationQueries(queryClient, [fieldId], farmId),
  });
};
